<template>
  <div class="c-publicHolidays">
    <div
      class="o-heading o-heading--border o-grid o-grid--gutter-tiny o-grid--align-items-center"
    >
      <div class="o-grid__group">
        <div class="o-grid__item">
          <h3 class="o-heading o-heading--bold o-heading--size-3">
            {{ translationsPublicHolidays.sectionName || name }}
          </h3>
        </div>
      </div>
    </div>
    <div
      v-for="(holiday, index) in rearrangedHolidays"
      :key="index"
      class="o-grid o-grid--gutter-large o-grid--padding-none o-grid--align-items-start o-field o-field--spacing-none o-field--border"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--4">
          <div class="o-label" :title="translateHoliday(holiday) || ''">
            {{ translateHoliday(holiday) || "" }}
          </div>
        </div>
        <div class="o-grid__item o-grid__item--4">
          <v-select
            :key="resetKey"
            label="name"
            v-model="availabilityAll.holidays[holiday].status"
            :options="availabilityOptions"
            :class="{ active: isEditing }"
            :reduce="option => option.value"
            :searchable="true"
            :clearable="false"
            :filterBy="filterDropdownFistLetter"
            :disabled="!isEditing"
            :selectOnTab="true"
            @input="setClosed($event, holiday)"
          ></v-select>
        </div>
        <div
          v-if="availabilityAll.holidays[holiday].timespans.length > 0"
          class="o-grid__item o-grid__item--4"
        >
          <div
            v-for="(span, spanIndex) in availabilityAll.holidays[holiday]
              .timespans"
            :key="spanIndex"
            class="o-grid o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-10"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--grow-0">
                <v-time
                  v-model="span.begin"
                  :disabled="!isEditing"
                  :class="{
                    active: isEditing
                  }"
                />
              </div>
              <div
                class="o-grid__item o-grid__item--1"
                style="text-align:center;"
              >
                -
              </div>
              <div class="o-grid__item o-grid__item--grow-0">
                <v-time
                  v-model="span.end"
                  :disabled="!isEditing"
                  :class="{
                    active: isEditing
                  }"
                />
              </div>
              <div class="o-grid__item o-grid__item--2">
                <button
                  v-if="isEditing && spanIndex > 0"
                  class="o-button o-button--action o-button--round o-button--light"
                  @click="deleteTimeSpan(holiday, spanIndex)"
                >
                  <svg
                    class="o-svg-icon o-button__icon"
                    viewBox="0 0 64 64"
                    type="image/svg+xml"
                  >
                    <use
                      xlink:href="spritemap.svg#sprite-delete"
                      x="0"
                      y="0"
                    ></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="isEditing && canAddSpans(holiday)"
            class="o-grid o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-10"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--12">
                <button
                  type="button"
                  class="o-button o-button--transparent o-button--clean"
                  :title="translationsPublicHolidays.addPeriod || ''"
                  @click="addTimeSpan(holiday)"
                >
                  {{ translationsPublicHolidays.addPeriod || "" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "c-publicHolidays",
  data() {
    return {
      section: "availability",
      name: "Helligdage",
      resetKey: 0
    };
  },
  props: {
    isEditing: { type: Boolean, default: false }
  },
  computed: {
    ...mapState("availability", {
      availabilityAll: "all",
      defaultTimeSpan: "defaultTimeSpan"
    }),
    ...mapState("translations", {
      translationsAvailabilityFull: "availability"
    }),
    translationsPublicHolidays() {
      return this.translationsAvailabilityFull.publicHolidays;
    },
    rearrangedHolidays() {
      const holidays = Object.keys(this.availabilityAll.holidays);
      holidays.push(holidays.shift());
      return holidays;
    },

    availabilityOptions() {
      const availabilityOptions = [
        {
          name: this.translationsPublicHolidays.state[0] || "",
          value: "Unspecified"
        },
        {
          name: this.translationsPublicHolidays.state[1] || "",
          value: "Closed"
        },
        {
          name: this.translationsPublicHolidays.state[2] || "",
          value: "Open"
        }
      ];
      return availabilityOptions;
    }
  },
  methods: {
    translateHoliday(name) {
      const holiday = this.translationsPublicHolidays.holiday.find(
        option => option.name === name
      );
      return holiday.value;
    },
    setClosed(value, name) {
      let item = this.availabilityAll.holidays[name];
      item["status"] = value;
      if (item["status"] === "Unspecified" || item["status"] === "Closed") {
        item.timespans.length = 0;
      }
      if (item["status"] === "Open") {
        this.$set(
          item.timespans,
          0,
          JSON.parse(JSON.stringify(this.defaultTimeSpan))
        );
      }
    },
    addTimeSpan(dayName) {
      this.availabilityAll.holidays[dayName].timespans.push(
        JSON.parse(JSON.stringify(this.defaultTimeSpan))
      );
    },
    deleteTimeSpan(dayName, spanIndex) {
      this.availabilityAll.holidays[dayName].timespans.splice(spanIndex, 1);
    },
    canAddSpans(name) {
      const canAddSpans =
        this.availabilityAll.holidays[name].status === "Open" &&
        this.availabilityAll.holidays[name].timespans.length < 3;
      return canAddSpans;
    }
  }
};
</script>

<style lang="scss"></style>
